<template>
	<div id="app">
		<router-view :key="$route.fullPath" v-if="isRouterAlive" />
		<!-- @todo 偷懒行为 - 如果美元化项目开关关了，就全局设置样式。隐藏括号里的值 -->
		<!-- <component :is="'style'" v-if="!isDollarEnabled">
			.mini_shelf_price{ display:none !important; }
		</component> -->
	</div>
</template>
<script>
import { getUrlFragment, getUrlQuery, plateForm, isActivityPath, isRoomPath} from "@/utils";
import OpenApp from "@/common/openApp";
import api from "@/api/api_list";
import { decode } from "jsonwebtoken";

const openApp = new OpenApp();
let jumpType = getUrlQuery("jumpType"),
	jumpId = getUrlQuery("jumpId");
const isChrome = navigator.userAgent.toLowerCase().match(/(Chrome|CriOS|GSA)/ig);

import { bindInviteCodeKey } from "@/constant/storageKey";
import { mapState, mapMutations } from "vuex";
export default {
	data() {
		return {
			isRouterAlive: true,
			isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
			isInApp: plateForm().app,
		};
	},
	computed: {
		...mapState("home", ["isDollarEnabled", 'priceSwitchStatus']),
	},

	provide() {
		return {
			reload: this.reload,
			isMobile: this.isMobile,
		};
	},

	methods: {
		...mapMutations("home", ["setDollarEnabledStatus", 'setPriceSwitchStatus']),

		reload() {
			this.isRouterAlive = false;
			this.$nextTick(() => {
				this.isRouterAlive = true;
			});
		},
		thirtPartLogin() {
			const params = getUrlFragment();
			if (params.state === "fromApple") {
				this.thirdPartyLoginInvoke(params);
				return true;
			}

			return false;
		},

		async thirdPartyLoginInvoke(params) {
			const payload = decode(params.id_token);

			const { result, code } = await api.third_party_login({
				appleLoginReq: {
					aud: payload.aud,
					jwt: params.id_token,
					code: params.code,
					sub: payload.sub,
					givenName: "",
					familyName: "",
					email: "",
				},
				loginType: 1,
			});

			if (code == 0) {

				if (result.bindMobile && result.bindMobile == 1) {

					result.intgUser.userWeixinId = result.userWeixinId;
					result.intgUser.userPartyId = result.userPartyId;
					result.intgUser.userAppleId = result.userAppleId;

					// 需要绑定
					this.$bindMobile.open({
						token: result.token,
						userInfo: result.intgUser,
						bindComplete: function () {

							const { userNum, inviteUserNum } = this.$storage.get("user_info") || {};

							if ( !this.$storage.get(bindInviteCodeKey + userNum)  && !inviteUserNum ) {

								this.$bindInviteCode.open({
									bindComplete: function (bindResult) {
										// if (bindResult) {
										// 	this.$downloadGuide.open();
										// }
									}.bind(this),
								});
								
							}

						}.bind(this),
					});

				} else {

					// 登录成功
					this.$storage.set("user_token", result.token);
					this.$storage.set("user_info", result.intgUser);
					this.$toast(this.$t("message.profile.loginSuccess"));

					const { userNum, inviteUserNum } = this.$storage.get("user_info") || {};

					if ( !this.$storage.get(bindInviteCodeKey + userNum) && !inviteUserNum ) {

						this.$bindInviteCode.open({
							bindComplete: function (bindResult) {
								// if (bindResult) {
								// 	this.$downloadGuide.open();
								// }
							}.bind(this),
						});

					}

				}

			}
		},

		shareOpen() {
			const that = this;

			// 尝试拉起app
			openApp._share2Scheme((queryObj) => {
				if (queryObj) {
					that.$shareGuide.open();
				} else {
					that.$isLogin();
				}
			});
		},

		setArms() {
			let userInfo = this.$storage.get("user_info");
			if (userInfo) {
				window.__bl.pipe = [
					[
						"setConfig",
						{
							setUsername: function () {
								return userInfo.userNum;
							},
							uid: this.getDeviceId(),
						},
					],
				];
			} else {
				window.__bl.pipe = [
					[
						"setConfig",
						{
							uid: this.getDeviceId(),
						},
					],
				];
			}
		},

		getDeviceId() {
			if (!this.$storage.get("h5_deviced_id")) {
				this.$storage.set(
					"h5_deviced_id",
					Number(
						Math.random().toString().substr(3, length) + Date.now()
					).toString(36)
				);
			}
			return this.$storage.get("h5_deviced_id");
		}
	},

	async created() {
		// 2.20需求：需要对括号价格、划价、折扣字符串单独控制（由服务端确定），但是socket服务端控制不了，需要前端取开关接口做兼容
		try {
			const { result, code } = await api.get_dollar_enabled_status();
			// {
			// 	"code": 0,
			// 	"msg": "请求成功",
			// 	"result": {
			// 		"showShelf": 0,
			// 		"showOrigin": 1,
			// 		"dollarEnabled": 1,
			// 		"showDiscount": 0
			// 	}
			// }
			if (code === 0 && result) {
				this.setPriceSwitchStatus( result );
				// 显示上架价格（括号价格）
				// if( result.showShelf === 1 ){
				// 	// 
				// }

				// // 显示划价
				// if( result.showOrigin ){
				// 	// 
				// }

				// // 显示折扣价
				// if( result.showDiscount ){
				// 	// 
				// }

				// 美元化开关
				// if( result.dollarEnabled === 0 ){
				// 	this.setDollarEnabledStatus(false);	
				// }
			}
		} catch (e) {
			console.log(e);
		}
	},

	mounted() {
		
		const isThirtPartLogin = this.thirtPartLogin();

		// 不是第三方登录 ，弹出下载引导
		if (!isThirtPartLogin) {

			//@todo 219需求，注释this.shareOpen方法。原因：分享出来的界面不弹下载引导了
			// this.shareOpen();

			// pathname以 不能是/activity开关的 开头的页面默认唤起app
			if( !isActivityPath() && !this.isInApp){

				try{
					// 自动唤起app（未安装时不自动跳下载）
					// ios && 只有chrome & 允许被唤起路由 & 第一次进页面时， 使用schema唤起
					if( plateForm().os === 'ios' && isChrome ){
						openApp.init({
							auto: false,
							isLink: false, // 这么做的原因：ios下，除chrome外 微信、飞书、safari都可以通过通用链唤起。如果是safari的话 全站通用链会自动唤起。
							action: {
								jumpType,
								jumpId
							},
						});
					}
				}catch(e){
					console.error(e);
				}
				setTimeout(()=>{
					this.$isLogin();
				}, 500);
				// openApp._share2Scheme((queryObj) => {
				// 	this.$isLogin();
				// });	
			}
			
		}

		this.setArms();

		// 每3分钟弹出登录界面
		setInterval( () => {

				// 不能是/activity开头的页面才有这个逻辑 ， activity的path是活动页,不需要跟主站页登录逻辑一致
				if( isActivityPath() ){
					return;
				}

				let bindMobileVisible = sessionStorage.getItem("bindMobileVisible");
				let loginVisible = sessionStorage.getItem("loginVisible");

				if ( (loginVisible == null || loginVisible == "false") && (bindMobileVisible == null || bindMobileVisible == "false") ) {
					this.$isLogin();
				}
		}, 1000 * 60 * 3 );
	},

	// 所有页面更新都会触发此函数
	updated() {
		let userInfo = this.$storage.get("user_info") || null;
		if (userInfo) {
			// 提交sdk连接请求
			this.$store.dispatch("connect");
			this.$store.dispatch("updateRefreshState");
		}
	},
};
</script>
<style lang="less">
.van-toast__text{
	white-space: normal;
    word-wrap: break-word;
    word-break: break-word;
}
@font-face {
	font-family: "TradeGothicLT";
	src: url(./assets/font/TradeGothicLT.ttf) format("truetype");
	font-style: normal;
	// font-weight: normal 500;
}
@font-face {
	font-family: "TradeGothicLT-Bold";
	src: url(./assets/font/TradeGothicLT-Bold.ttf) format("truetype");
	font-style: normal;
	font-weight: bold bolder 600;
}
@font-face {
	font-family: "TradeGothicNextLTPro-Hv";
	src: url(./assets/font/TradeGothicNextLTPro-Hv.otf) format("opentype");
}
@font-face {
	font-family: "Approach-SemiBold";
	src: url(./assets/font/Approach-SemiBold.otf) format("opentype");
}
@font-face {
	font-family: "Approach-Medium";
	src: url(./assets/font/Approach-Medium.otf) format("opentype");
}
@font-face {
	font-family: "approach-mono-bold";
	src: url(./assets/font/approach-mono-bold.otf) format("opentype");
}
@font-face {
	font-family: "approach-mono-medium";
	src: url(./assets/font/approach-mono-medium.otf) format("opentype");
}
@font-face {
	font-family: "Approach-Regular";
	src: url(./assets/font/Approach-Regular.otf) format("opentype");
}
body,
html {
	padding: 0;
	margin: 0;
	height: 100%;
	background-color: transparent;
	font-family: "TradeGothicLT", "Avenir", Helvetica, Arial, sans-serif !important;
}
body {
	font-size: 14px;
	padding-bottom: constant(safe-area-inset-bottom);
}
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	height: 100%;
	background-color: transparent;
}
ul,
li,
dl,
dt,
dd {
	box-sizing: border-box;
	list-style: none;
	font-style: normal;
	padding: 0;
	margin: 0;
}
p,
h1,
h2,
h3,
h4,
h5,
h6,
form,
fieldset,
legend,
img {
	margin: 0;
	padding: 0;
}
.global_pointer:hover {
	cursor : pointer
} 
van-tab van-button:hover{
	cursor : pointer
}
button:hover{
	cursor : pointer
}
</style>
